import { useEffect } from 'react'

import TemplateWafersWithControl from 'Components/UI/Templates/Vehicles/WafersWithControl'

const WafersWithControl = () => {
  useEffect(() => {
    document.title = 'Obleas con control'
  }, [])
  return <TemplateWafersWithControl />
}

export default WafersWithControl
